import React, { useState } from "react";
import stl from "./neckglassesModal.module.scss";

import { glassTypes, glassTypeVale } from "@/config/addToCarMap";
import { create } from "@/src/models/basket";
import { useTranslation } from "@/src/i18n/client";
import {
    FmButton,
    FmDrawer as FmUIDrawer,
    FmToast,
    IDrawerProps,
} from "@/ui-component";

interface Props extends IDrawerProps {
    addCartGA: () => void;
    color_id: number | string;
    product_id: number | string;
    pageId: number | null;
}
const NeckglassesModal: React.FC<Props> = (props) => {
    const { color_id, product_id, pageId, addCartGA, onClose } = props;
    const { t } = useTranslation(["rx", "common"]);
    //构造select函数
    const [toastVisible, setToastVisible] = useState(false);
    const [toastChilren, setToastChilren] = useState("");
    const [toastType, setToastType] = useState<"loading" | "info">("loading");
    const [value, setValue] = useState("");
    const onChange = (val: string) => {
        setValue(val);
    };

    function loadingToast() {
        setToastType("loading");
        setToastVisible(true);
    }

    function infoToast(msg: string) {
        setToastType("info");
        setToastChilren(msg);
        setToastVisible(true);
    }

    const onConfirm = () => {
        if (!value) {
            return;
        }
        const rxInfo: string = `{txt_2}${value}{txt_5}${value}`;
        const ids: any = {};
        ids[glassTypes] = glassTypeVale.near;

        const sendData = {
            cart_quantity: 1,
            color_id,
            product_id,
            ...ids,
            "id[rx]": rxInfo,
            page_id: pageId,
        };
        loadingToast();
        create(sendData)
            .then(() => {
                setToastVisible(false);
                location.href = "/basket";
                //添加GA统计
                try {
                    addCartGA();
                } catch (err) {
                    console.log(err);
                }
            })
            .catch((e) => {
                infoToast(e);
            });
    };
    return (
        <>
            <FmToast visible={toastVisible} type={toastType}>
                {toastChilren}
            </FmToast>
            <FmUIDrawer open={props.open} onClose={onClose} closeable>
                <div className={stl["neckglasses-container"]}>
                    <div className={stl["neckglasses-title"]}>
                        {t("rx:PrescriptionsLimit")}
                    </div>
                    <div className={stl["neckglasses-item-container"]}>
                        <div className={stl["select-item"]}>
                            <div className="select-item-ul">
                                {["+1.50", "+2.00", "+2.50"].map(
                                    (val: string, key: number) => (
                                        <div
                                            className={`${key % 2 ? "sub" : ""} ${
                                                value == val ? "active" : ""
                                            }`}
                                            key={key}
                                            onClick={() => {
                                                onChange(val);
                                            }}
                                        >
                                            {val}
                                        </div>
                                    ),
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={stl["neckglasses-close-btn"]}>
                        <FmButton disabled={!value} onClick={onConfirm}>
                            {t("common:btn._Confirm")}
                        </FmButton>
                    </div>
                </div>
            </FmUIDrawer>
        </>
    );
};

export default NeckglassesModal;
